/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Pele Megas Abakira",
  title: "I'm Pele",
  subTitle: emoji(
    "A creative and results-driven IT professional passionate about remote work, SEO, web development, and tech support. I help businesses grow their digital presence through automation, performance-optimized websites, and smart outreach system"
  ),
  resumeLink:
    "https://drive.google.com/file/d/1QAhLmjGXIcKzDgU0U8lsAFr6JQ-iPBYQ/view?usp=drive_link", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/m78pele",
  linkedin: "https://www.linkedin.com/in/pele-megas-bikanye-a96969285/",
  gmail: "phxdesigns.th@gmail.com",
  instagram: "https://www.instagram.com/pelemegas?igsh=MTRud3E3cTk4OXpwMA%3D%3D&utm_source=qr",
    // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false 
};

// Skills Section

const skillsSection = {
  title: "About Me",
  subTitle: "My Experts",
  skills: [
    emoji(
      "I'm a self-taught IT enthusiast currently working towards becoming a remote IT support professional. With hands-on experience across various tech disciplines, including SEO, web development, automation, and graphic design, I bring a well-rounded skill set to every project. My professional journey spans collaborations with international teams, startups, and training institutions. I thrive in high-learning environments and love turning complex problems into simple, effective solutions."
    ), 
    
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

 softwareSkills: [
  {
    skillName: "html-5",
    fontAwesomeClassname: "fab fa-html5"
  },
  {
    skillName: "css3",
    fontAwesomeClassname: "fab fa-css3-alt"
  },
  {
    skillName: "JavaScript",
    fontAwesomeClassname: "fab fa-js"
  },
  {
    skillName: "wordpress",
    fontAwesomeClassname: "fab fa-wordpress"
  },
  {
    skillName: "canva",
    fontAwesomeClassname: "fas fa-paint-brush" // no exact Canva icon in Font Awesome
  },
  {
    skillName: "zapier",
    fontAwesomeClassname: "fas fa-bolt" // custom icon approximation
  },
  {
    skillName: "airtable",
    fontAwesomeClassname: "fas fa-table" // custom icon approximation
  },
  {
    skillName: "it-support",
    fontAwesomeClassname: "fas fa-tools" // for general tech support tools
  }
],
display: true
}

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Nakivubo Adult School",
      logo: require("./assets/images/images.png"),
      subHeader: "Uganda Adversed Certificate Education",
      duration: "Jan 2025 - Present",
      desc: "Finalising my High School Certificate",
    },
    {
      schoolName: "Mother Kevin Senior Secondary School",
      logo: require("./assets/images/images.jpeg"),
      subHeader: "Uganda Adversed Certificate",
      duration: "January 2022 - Novemeber 2022",
    }

  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Graphic Design", //Insert stack or technology you have experience in
      progressPercentage: "80%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Web Development",
      progressPercentage: "60%"
    },
    {
      Stack: "Programming",
      progressPercentage: "60%"
    },
    {
      Stack: "Social Media Managment",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  subtitle: "Netherlands – Remote",
  experience: [
    {
      role: "SEO Specialist Interne",
      company: "Flowspark",
      companylogo: require("./assets/images/LinkedIn company logo.jpg"),
      date: "Janaury 2025 – June 2025",
      desc: "My role was to manage flowspark google accounts and mail box and SEO Link-build",
    },
    {
      role: "Business Development Trainee",
      company: "Coolfinity",
      companylogo: require("./assets/images/logo-rgb-colour_large.webp"),
      date: "June 2024 – Dec 2024",
      desc: "Conducted market research on healthcare refrigeration needs in Uganda"
    },
    {
      role: "Junior Web Designer",
      company: "MvdW in Business",
      companylogo: require("./assets/images/OIP.webp"),
      date: "Jun 2024 – Dec 2024",
      desc: "Designed a custom webshop, collaborated with remote team on woocommerce development"
    },
    {
      role: "IT Support Desk",
      company: "Nile Centre Busienss Support",
      companylogo: require("./assets/images/logo-light.png"),
      date: "Jan 2023 – Present",
      desc: "Provided helpdesk support, system setup, and IT equipment management"
    },
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */


// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS IN WEB AND ",
  projects: [
    {
      image: require("./assets/images/saayaHealthLogo.webp"),
      projectName: "Saayahealth",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://saayahealth.com/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/nextuLogo.webp"),
      projectName: "Nextu",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://nextu.se/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Udemy",
      subtitle:
        "Completed Certifcation from Udemy",
      image: require("./assets/images/Udemy.webp"),
      imageAlt: "Learned Web Design Using Wordpress, Digital Marketing and Ethical Hacking Basics",
      footerLink: [
        {
          name: "Certification",
          url: "https://www.udemy.com/certificate/UC-0ee71642-65dc-414c-b184-a978218e43b4/"
        },
        {
          name: "Certification",
          url: "https://www.udemy.com/certificate/UC-f217c5f4-45ac-439d-9904-a1f3bc183d57/"
        },
        {
          name: "Certification",
          url: "https://www.udemy.com/certificate/UC-0b4f21d5-d9b7-4724-a58a-7a3046bab971/"
        }
      ]
    },
    {
      title: "Zapier learn",
      subtitle:
        "Complited basic levels for Zapier Course",
      image: require("./assets/images/download.png"),
      imageAlt: "Automate your work",
      footerLink: [
        {
          name: "Certificate",
          url: "https://verify.skilljar.com/c/ybj3tpdz4ix5"
        },
        {
          name: "Certificate",
          url: "https://verify.skilljar.com/c/66oicbe6uae6",
        }
      ]
    },

    {
      title: "Make.com",
      subtitle: "Completed Badge for Basics and Intermidiate courses",
      image: require("./assets/images/make.com.png"),
      imageAlt: "Make.com Logo",
      footerLink: [
        {
          name: "Badge", 
          url: "https://www.credly.com/users/pele-megas-bikanye-3"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
}; 

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+256 747292223",
  email_address: "phxdesigns.th@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: true // Set true to display this section, defaults to false
};

const isHireable = false; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
   bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
